import {nilStudentAthletes} from "./solutions/nil-student-athletes";
import {rideSharing} from "./solutions/ride-sharing";
import {filmCrew} from "./solutions/film-crew";
import {hairCareProfessionals} from "./solutions/hair-care-professionals";
import {influencers} from "./solutions/influencers";

export type Solution = {
  name: any;
  description: any;
  icon: any;
  hero: {
    head: any;
    deck: any;
    primaryButton: {
      onClick?: any;
      link?: string;
      text: any;
    };
    imageSrc: string;
    bullets?: any[];
    imageBullets: Array<{
      iconSrc: string;
      text: any;
    }>;
  };
  savings: {
    head: any;
    deck: any;
    imageSrc: string;
    income: string;
    expenses: string;
    contribution: string;
  };
  advisor: {
    head: any;
    deck: any;
    imageSrc: string;
    chat: {
      messages: any[];
      advisor: {
        name: any;
        title: any;
        avatarSrc: string;
      };
      button: {
        onClick?: any;
        link?: string;
        text: any;
      };
    };
  };
  expenses: {
    head: any;
    deck: any;
    imageSrc: string;
    transactions: Array<{
      brandImageSrc: string;
      brandName: any;
      price: any;
      date: any;
      category: any;
    }>;
  };
  features: {
    head: any;
    deck: any;
    cards: Array<{
      title: any;
      description: any;
      imageSrc: string;
    }>;
  };
  callToAction: {
    head: any;
    deck?: any;
    primaryButton: {
      onClick?: any;
      link?: string;
      text: any;
    };
  };
};
type Solutions = Record<string, Solution>;

export const solutions: Solutions = {
  "nil-student-athletes": nilStudentAthletes,
  "ride-sharing": rideSharing,
  "hair-care-professionals": hairCareProfessionals,
  "influencers": influencers,
  "film-crew": filmCrew,
};
